import { render, staticRenderFns } from "./ed-select-tabs.component.vue?vue&type=template&id=2eef1ca8&scoped=true&"
import script from "./ed-select-tabs.component.ts?vue&type=script&lang=ts&"
export * from "./ed-select-tabs.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-select-tabs.component.scss?vue&type=style&index=0&id=2eef1ca8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eef1ca8",
  null
  
)

export default component.exports